import { useSelector, useDispatch } from "react-redux";
import { setCredentials, clearCredentials } from "../store/authSlice";
import * as authApi from "../api/auth";

export default function useAuth() {
  const dispatch = useDispatch();
  const { user, isAuthenticated, isInitializing } = useSelector((s) => s.auth);

  const login = async (email, password) => {
    const result = await authApi.login(email, password);
    console.log(
      "[auth] login success:",
      result.user?.email,
      "| token:",
      !!result.token,
    );
    dispatch(setCredentials(result));
    return result;
  };

  const register = async (email, password, inviteCode) => {
    const result = await authApi.register(email, password, inviteCode);
    console.log(
      "[auth] register success:",
      result.user?.email,
      "| token:",
      !!result.token,
    );
    dispatch(setCredentials(result));
    return result;
  };

  const logout = async () => {
    await authApi.logout();
    console.log("[auth] logged out");
    dispatch(clearCredentials());
  };

  return { user, isAuthenticated, isInitializing, login, register, logout };
}
